import { useEffect,useRef } from "react";
import { useNavigate } from "react-router-dom";

function Protected(props){

    const {Component} = props;
    const navigate = useNavigate();
    // const [storedData, setstoredData] = useState('');
    const storedData = useRef(null);

    useEffect( ()=>{
      console.log('while page enters ')
              // Retrieve data from localStorage when the component mounts
            //   setstoredData(localStorage.getItem('isAdminLogin'));
            storedData.current = localStorage.getItem('ai-admin');
              if (storedData.current) {
                navigate('/job-post');
              }else{
                navigate('/login');
              }
    },[storedData,navigate]);

    return(
        <div>
            <Component />
        </div>
    )

}

export default Protected